export const MOBILE_DRAWER_BREAKPOINT = 'md';
export const DRAWER_WIDTH = 280;
export const DRAWER_EXPANDED_WIDTH = 227;
export const DRAWER_COLLAPSED_WIDTH = 52;
export const FONT_URL =
    'https://fonts.googleapis.com/css2?family=Inter:ital,wght@0,400..700;1,400..700&display=swap';
